<template>
  <div>
    <p class="text-sm font-semibold">Sucursal {{ branch.name }}</p>
    <p class="text-sm">
      {{ branch.address.street }} {{ branch.address.exterior_number
      }}{{ branch.address.interior_number ? " " + branch.address.interior_number : "" }}
    </p>
    <p v-if="branch.address.neighborhood" class="text-sm">
      {{ branch.address.neighborhood }}
    </p>
    <p class="text-sm">{{ branch.address.city }}, {{ branch.address.state.name }}</p>
    <p class="text-sm">México</p>
    <p class="text-sm">{{ branch.address.zip_code }}</p>
  </div>
</template>

<script>
export default {
  name: "Branch Info",

  props: {
    branch: Object,
  },
};
</script>